import React from 'react'

const ViewVoice = () => {
  return (
    <div>ViewVoice</div>
  )
}

export default ViewVoice